:host {
  display: block;
}

.spw-footer-content-col {
  &__title {
    font-size: 18px;
    margin-bottom: 16px;
    font-weight: 700;
  }

  &__contact {
    transition: all linear 0.2s;
    margin-bottom: 16px;
    &:hover {
      opacity: 0.7;
    }
  }
}

::slotted(a) {
  position: relative;
  display: block;
  text-decoration: none;
  color: var(--spw-ds-white);
  padding-left: 18px;
  margin-bottom: 12px;
  font-size: 16px;

  &:after {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--spw-ds-primary);
  }
}

::slotted(a:hover) {
  color: var(--spw-colors-support-grey-grey-500) !important;
}
